import { ReactElement } from 'react'

import { I18nShape } from '@tribeplatform/react-components/i18n'
import { SvgIconName } from '@tribeplatform/react-ui-kit/Icon'

import { AdminModeDropDownItem, AdminModeSheetItem } from './AdminModeItem.js'
import {
  DesignModeDropDownItem,
  DesignModeSheetItem,
} from './DesignModeItem.js'
import {
  ModerationModeDropDownItem,
  ModerationModeSheetItem,
} from './ModerationModeItem.js'

import { RouteMode } from './index.js'

type ModeAppearance = {
  label: string
  element: ReactElement
  icon: SvgIconName
  sheetElement: ReactElement
}

export const routeModeFactory = ({
  $t,
}: I18nShape): Partial<Record<RouteMode, ModeAppearance>> => ({
  admin: {
    label: $t({
      defaultMessage: 'Administration',
      id: 'Generics.Administration',
    }),
    icon: 'settings',
    element: <AdminModeDropDownItem />,
    sheetElement: <AdminModeSheetItem />,
  },
  design: {
    label: $t({
      defaultMessage: 'Design Studio',
      id: 'Generics.DesignStudio',
    }),
    icon: 'drawing-compass',
    element: <DesignModeDropDownItem />,
    sheetElement: <DesignModeSheetItem />,
  },
  moderation: {
    label: $t({
      defaultMessage: 'Moderation',
      id: 'Generics.Moderation',
    }),
    icon: 'moderation',
    element: <ModerationModeDropDownItem />,
    sheetElement: <ModerationModeSheetItem />,
  },
})
